module.exports = __webpack_public_path__ + "img/Réalisation portail 2 vantaux.7180874d.jpg";